import { ModalTypes, useSearchParamModal } from 'hooks/useSearchParamModal';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

const QuizViewProxy = () => {
  const navigate = useNavigate();
  const params = useParams();
  let schoolId = useSelector(s => s.school.schoolId);
  const [search, _] = useSearchParams();
  const { navigateToModal } = useSearchParamModal();
  const token = search.get("token");

  if (schoolId === null) {
    schoolId = 'B2B';
  }

  useEffect(() => {
    if (!params?.shortCode) {
      navigate('/');
    } else {
      navigateToModal({
        modalType: ModalTypes.SetWork,
        meta: {
          stage: 'topics',
          quizShortCode: params.shortCode,
        },
        baseUrl: `/${schoolId}`,
        extra: token ? `token=${token}` : null,
      });
    }
  }, [navigate, navigateToModal, params.shortCode, schoolId]);
};

export default QuizViewProxy;
